import styled from 'styled-components';

export const Clickable = styled.div`
  cursor: pointer;
`;
